import { useNavigate } from 'react-router-dom';
import { useContent } from '@/services/siteData';
import { HeroSlider } from '@/components/HeroSlider';
import { TriDivider } from '@/components/TriDivider';
import { IcoChevronDown } from '@/components/icons';
import { Seo } from '@/components/Seo';

export function HomePage() {
  const navigate = useNavigate();
  const { home } = useContent();

  return (
    <div className="page-fade">
      <Seo
        title="Wholesale Patisserie Supplier — Food Service UK"
        description="Premium French patisserie for restaurants, hotels and catering businesses. Trade accounts only — nationwide delivery from our London kitchen."
        path="/"
      />
      <section className="hero">
        <HeroSlider />
        <div className="hero-tagline">{home.tagline}</div>
        <button
          className="scroll-chevron"
          onClick={() => window.scrollTo({ top: window.innerHeight * 0.7, behavior: 'smooth' })}
          aria-label="Scroll down"
        >
          <IcoChevronDown />
        </button>
      </section>

      <TriDivider />

      {home.promos.map((p, i) => (
        <div key={p.title}>
          <section className={'promo' + (i % 2 ? ' flip' : '')}>
            <div className="promo-text">
              <h2>{p.title}</h2>
              {p.body.map((t, n) => (
                <p key={n}>{t}</p>
              ))}
            </div>
            {p.img ? (
              <div className="promo-media" style={{ backgroundImage: `url(${p.img})` }} />
            ) : null}
          </section>
          {i < home.promos.length - 1 && <div className="promo-divider" />}
        </div>
      ))}

      <section className="order-cta">
        <div className="member">Ready to order?</div>
        <h3>Discover our range available to order now.</h3>
        <a
          className="phone"
          onClick={() => navigate('/order/afternoon-tea')}
          style={{ cursor: 'pointer', borderBottom: '1px solid var(--pink)' }}
        >
          View Available to Order
        </a>
      </section>
    </div>
  );
}
